import { useState } from "react";
import './ApiBlockArea.css'
import ReactTextareaAutosize from "react-textarea-autosize";

function ApiBlockArea({value, setValue, onBlur}) {

    const [body, setBody] = useState(value)
    
    // DisableSpellCheck need to be some when the composent is mounted, no use effect yes !
    const disableSpellCheck = (ref) => {
        if(!ref) {
            return;
        }
        ref.spellcheck = false
    }

    const onChange = (e) => {
        setBody(e.target.value)
        setValue(e.target.value)
    }

    return (
        <div style={{ width : 'calc(100% - 10px)'}}>
            <ReactTextareaAutosize ref={(ref) => disableSpellCheck(ref)} style={{ marginTop : 20, marginLeft : 10}} value={body} onChange={onChange} onBlur={onBlur} className="input editor-input title_input" placeholder='{}' minRows={3}/>
        </div>
    )
}

export default ApiBlockArea